import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import useDebounce from 'hooks/useDebounce';
import { trackPageView } from 'utils/mixpanel.utils';

// Debounce so a mount-then-`history.replace` (default-view filters) collapses
// into a single page view with the final search params.
const TRACK_DEBOUNCE_MS = 300;

// Tracks a Mixpanel page view every time the user navigates to a new route.
const useTrackPageViews = (): void => {
  const location = useLocation();
  const settledLocation = useDebounce(location, TRACK_DEBOUNCE_MS);
  const referrerRef = useRef<string>();

  useEffect(() => {
    if (!settledLocation) {
      return;
    }

    trackPageView(settledLocation, referrerRef.current);
    referrerRef.current = `${settledLocation.pathname}${settledLocation.search}`;
  }, [settledLocation]);
};

export default useTrackPageViews;
